// extracted by mini-css-extract-plugin
export var actions = "_st-4";
export var item = "_st-1";
export var price = "_st-3";
export var quantity = "_st-2";
export var table = "_st-0";